export default __webpack_public_path__ + "static/media/solo-chamber-clarinet-generic.637bf710.png";